<script lang="ts" setup>
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DynamicUIDetail } from "~/modules/dtwin/models/DynamicUIDetail.interface";

defineProps<{
  dtwin?: Dtwin;
  uiConfigFirmware?: Record<string, Record<string, DynamicUIDetail[]>>;
}>();

const { t } = useI18n();
</script>

<template>
  <block-container
    v-if="uiConfigFirmware?.information && dtwin"
    :title="t('dtwins.form.firmware.title')"
    title-top
  >
    <template #left>
      <dtwin-form-field
        v-for="item in uiConfigFirmware.information.left"
        :key="item.id"
        :dtwin="dtwin"
        :item="item"
      />
    </template>
    <template #right>
      <dtwin-form-field
        v-for="item in uiConfigFirmware.information.right"
        :key="item.id"
        :dtwin="dtwin"
        :item="item"
      />
    </template>
  </block-container>
</template>
